<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1 calibre1" id="dixie1">
<p class="normal-241-0-override"><span class="no-style-override">DIXIE’S LAST STAND</span></p>
<p class="normal-241-0-override"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-241-0-override"><span class="no-style-override1">Was it Murder or Self-Defense?</span></p>
<p class="normal-241-0-override"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-241-0-override"><span class="no-style-override2">An Original True-Crime Feature</span></p>
<p class="normal-241-0-override"><span class="no-style-override2">by John Ferak, WildBlue Press</span></p>
<p class="calibre2" id="calibre_pb_0"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?36bb0afe